<template>
  <DialogBase
    :visible="dialogVisible"
    title="Thông báo hệ thống"
    width="70%"
    top="2vh"
    :close-on-click-modal="false"
    panel-icon="el-icon-bell"
    panel-title="Nội dung thông báo"
    panel-subtitle="Xem nội dung và tải xuống các file đính kèm"
    :show-footer="false"
    @update:visible="handleVisibleUpdate"
  >
    <div class="hr">
      <hr />
    </div>

    <div class="table-content row-data">
      <div class="title">
        <span class="label">Tiêu đề :</span>
        {{ this.viewContent.sendTitle }}
      </div>

      <div class="content">
        <span class="label">Nội dung :</span>
        <el-input type="textarea" v-model="this.viewContent.sendContent" :rows="10" readonly>
        </el-input>
      </div>

      <div class="file">
        <span class="label">File đính kèm :</span>
        <!-- <el-upload
          class="upload-demo"
          style="margin-top: 20px"
          action
          :file-list="viewContent.urlFileAppSendList"
          :on-preview="handleFileRequest"
          limit="3"
        >
        </el-upload> -->

        <el-upload
          class="upload-demo"
          ref="upload"
          style="margin-top: 10px"
          action
          multiple
          :auto-upload="false"
          :limit="5"
          :file-list="viewContent.urlFileAppSendList"
          :on-preview="handleFileRequest"
        >
        </el-upload>
        <!-- <div class="hasagi" style="margin-bottom: 20px">
          <el-button type="danger" @click="closeDialog()" icon="el-icon-circle-close"
            >Đóng</el-button
          >
        </div> -->
      </div>
    </div>
  </DialogBase>
</template>

<script>
import AppSendService from "@/services/AppSendService";
import http from "../../http-download";
import DialogBase from "@/components/DialogBase.vue";
export default {
  components: { DialogBase },
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      viewContent: {
        sendTitle: "",
        sendContent: "",
        urlFileAppSendList: [],
      },
    };
  },
  methods: {
    handleVisibleUpdate(value) {
      if (!value) {
        this.closeDialog();
      }
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold";
    },
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {}, 100);
    },
    tableRowStyle({ row }) {
      if (!row.userUnread) {
        return "color: #409EFF";
      }
    },
    handleFileRequest(file) {
      let a = file;
      console.log(a);
      let extensionFile = file.name.split(".").pop();
      let label = file.name;
      let idUrlFileAppsend = file.id;
      this.downloadItem(label, extensionFile, idUrlFileAppsend);
    },
    downloadItem(label, extensionFile, idUrlFileAppsend) {
      http
        .get(`/appsend/appsendowload/${idUrlFileAppsend}`)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", label);
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            message: "Thất bại",
            type: "error",
          });
        });
    },
    getDetailMethod(id) {
      AppSendService.getById2(id)
        .then((resp) => {
          let data = (this.viewContent = resp.data.data);
          this.content = data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";

.table-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.label {
  display: inline-block;
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: 600;
}

.title {
  margin-top: 0;
  margin-bottom: 0;
  font-family: Arial;
  font-size: 18px;
}

.hasagi {
  float: right;
  margin-top: -10px;
}

.content {
  margin-top: 0;
  font-family: Arial;
  font-size: 18px;
}

/deep/.el-table .cell {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding-right: 10px;
  word-break: break-word;
}

/deep/.el-textarea__inner {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 1.5;
  box-sizing: border-box;
  width: 100%;
  word-break: break-word;
  color: #606266;
  font-size: 14px;
  background-color: #f0f0f0;
  background-image: none;
  border-radius: 4px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.file {
  margin-top: 0;
  font-family: arial;
}

.hr {
  margin-top: 0;
  margin-bottom: 12px;
}

/deep/el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}

/deep/.el-upload-list__item .el-icon-upload-success {
  color: #ffffff !important;
}

/deep/.el-upload-list__item .el-icon-close {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  opacity: 0.75;
  color: #ffffff;
}

/deep/.el-upload-list {
  margin: 0;
  padding: 0;
  list-style: none;
  margin-top: 8px !important;
}

/deep/.el-upload-list__item-name {
  color: #606266;
  display: block;
  margin-right: 40px;
  overflow: hidden;
  padding-left: 4px;
  text-overflow: ellipsis;
  transition: color 0.3s;
  white-space: nowrap;
  margin-bottom: 15px;
  line-height: 15px;
  margin-left: 20px;
}

/deep/.el-upload-list__item .el-icon-close-tip {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 0px;
  cursor: pointer;
  color: #409eff;
}
</style>
